import type { MediaKind } from "../../engine/types";
import type { ToolId } from "./types";

export const STAGE_INSETS = {
  desk: { top: 76, right: 24, bottom: 24, left: 24 }, // 76 = 12 + 52 (toolbar at coarse size) + 12
  focusPhone: { top: 12, right: 12, bottom: 12, left: 12 },
  resume: { top: 8, right: 8, bottom: 8, left: 8 },
} as const;
export const ZOOM_STEPS = [0.25, 0.33, 0.5, 0.67, 1, 1.5, 2, 3, 4, 6, 8] as const; // plus "fit"
export const ZOOM_MAX = 8;

/** Owner decision (spec §12.1): a phone opens media straight into full screen. */
export const AUTO_FULLSCREEN_ON_PHONE = true;
/** Owner decision (spec §12.3): the tool shown right after opening. */
export const DEFAULT_TOOL: Record<MediaKind, ToolId> = { image: "filters", video: "trim" };
/** Owner decision (spec §12.9): site amber. */
export const DRAW_DEFAULT_COLOR = "#f4be52";

/** Every way of writing "off" the kill switch takes (any case, spaces around it ignored). */
const OFF_VALUES = new Set(["off", "false", "0", "no", "disabled", "disable"]);

/** VITE_CHOPBOX_AI → AI on? Unset or empty: on (the owner's default). Any spelling of "off": off. */
export function aiFlagOn(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  if (value === false || value === 0) return false;
  const v = String(value).trim().toLowerCase();
  return !OFF_VALUES.has(v);
}

function readAiFlag(): boolean {
  try {
    return aiFlagOn(import.meta.env?.VITE_CHOPBOX_AI);
  } catch {
    return true;
  }
}

/**
 * Owner decision (Phase 2 addendum §1, 2026-09-25): the AI tools are ON by default; every device
 * self-tests on first use and hides what fails. VITE_CHOPBOX_AI=off at build time is the kill switch
 * (OFF, false, 0 and no work too). Read here, never in engine modules.
 */
export const AI_ENABLED: boolean = readAiFlag();
